import React, { useEffect } from 'react';

export type FloatingPopUpProps = React.PropsWithChildren & {
  className?: string;
  style?: React.CSSProperties;
  visible: boolean;
  position?: { x: number; y: number } | null;
};

export const FloatingPopUp: React.FC<FloatingPopUpProps> = ({
  children,
  style,
  className,
  visible,
  position,
}) => {
  const popUpRef = React.useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!popUpRef.current || !position) {
      return;
    }
    const posPadding = { x: 8, y: 8 };
    const willOverflowRight =
      position.x + popUpRef.current.offsetWidth + posPadding.x >
      window.innerWidth;

    popUpRef.current.style.bottom = `${
      window.innerHeight - position.y + posPadding.y
    }px`;

    if (willOverflowRight) {
      popUpRef.current.style.left = `${
        position.x - posPadding.x - popUpRef.current.offsetWidth
      }px`;
    } else {
      popUpRef.current.style.left = `${position.x + posPadding.x}px`;
    }
  }, [position, popUpRef.current]);

  return (
    <div
      ref={popUpRef}
      className={className}
      style={{
        width: '128px',
        display: visible ? 'flex' : 'none',
        position: 'absolute',
        zIndex: 1000,
        overflow: 'visible',
        ...style,
      }}
    >
      {children}
    </div>
  );
};
